import { observable, autorun, action, toJS, map, computed } from 'mobx';

class BFLayers{
   currentViewId = 1;
   views = [];

   @observable currentLayers = [];

   canvasElemScalingTimer = null;
   notifyQualityTimer = null;

   constructor(){

     $(window).on('MediaManager-addLayer',(e,obj)=>{

       var obj2 = _.clone(obj);
       obj2.idImg = obj.id;
       var layer = this.prepareLayer(obj2);

       $(window).trigger('Layers-addLayerToCanvas',layer);
       //console.log('tr Layers-addLayerToCanva');
     })

     $(window).on('WorkArea-layer-added',(e,obj)=>{
       //console.log('WorkArea-layer-added');
       this.addLayer(obj);
       this.currentLayers = this.getCurrentViewTable();
     })

     $(window).on('WorkArea-addLayerFromData CCC-addLayerFromData',(e,obj)=>{
       //console.log('WorkArea-addLayerFromData CCC-addLayerFromDat');
       this.addLayer(obj);
     })

     $(window).on('Layers-removeLayer',(e,id)=>{

       this.removeLayerById(id);
       $(window).trigger('bf-transform',{'action':'remove','idLayer':id});
       this.currentLayers = this.getCurrentViewTable();
     })

     $(window).on('MediaManager-removeImage',(e,obj)=>{

       var layer_id = this.getLayerByIdImg(obj.id);

       if ( this.getCurrentViewTable(layer_id) !== undefined )
       {
         $(window).trigger('bf-transform',{'action':'remove','idLayer':bfLayers.getCurrentViewTableId(layer_id)});

         this.removeLayerById(this.getCurrentViewTableId(layer_id));
         this.currentLayers = this.getCurrentViewTable();
       }
     })


     $(window).on('WorkArea-canvasElemScaling',(e,obj)=>{



       if ( ! bfLayers.getLayerById(obj.idLayer) ) return;
       if( bfLayers.getLayerById(obj.idLayer).instance.svg == true ) return;

       var prevQuality = bfLayers.getLayerById(obj.idLayer).quality;

       clearTimeout(this.canvasElemScalingTimer);
       this.canvasElemScalingTimer = setTimeout(()=>{

         var timeObj = new Object();
         timeObj.quality = obj.quality;
         timeObj.prevQuality = prevQuality;

         //notifyQualityTimer = setTimeout(testQuality,500,timeObj);
         this.notifyQualityTimer = setTimeout( ()=>{this.testQuality(timeObj)},500,timeObj);

         this.getLayerById(obj.idLayer).quality = obj.quality;

         this.currentLayers = this.getCurrentViewTable();

       },200)

     })


     $(window).on('SingleProject-prepareViews',(e,viewsObj)=>{

       this.addViews(viewsObj);

     })

     $(window).on('SingleProject-setViews',(e,id)=>{

       this.cleanView(id);
       this.setCurrentViewId(id);
       //bfCreateLayers();
       this.currentLayers = this.getCurrentViewTable();

     })

     $(window).on('WorkArea-crop',(e,obj)=>{

       if ( ! bfLayers.getLayerById(obj.idLayer) ) return;
       if( bfLayers.getLayerById(obj.idLayer).instance.svg == true ) return;
       bfLayers.getLayerById(obj.idLayer).idCrop = obj.idCrop;
       bfLayers.getLayerById(obj.idLayer).idImage = obj.id;
       bfLayers.getLayerById(obj.idLayer).pathCrop = obj.pathCrop;

     })

   }

   testQuality(obj){

      if (  obj.prevQuality == obj.quality || ( obj.prevQuality == undefined && obj.quality == 'good' )  )
      {
        return;
      }
      $(".notifyjs-wrapper").click();
      if ( obj.quality == 'low' )
      {
        var obj_notify = new Object();
        obj_notify.title = 'Warning';
        obj_notify.text = 'Oh oh. The current image has a low quality.';
        obj_notify.type = 'warning';
        $(window).trigger('notify',obj_notify);

      }
      if ( obj.quality == 'very-low' )
      {
        var obj_notify = new Object();
        obj_notify.title = 'Warning';
        obj_notify.text = 'Ups. The current image has a very low quality. Please choose another one.';
        obj_notify.type = 'error';
        $(window).trigger('notify',obj_notify);
      }

      if ( obj.prevQuality !== 'good' && obj.quality == 'good' )
      {
        var obj_notify = new Object();
        obj_notify.title = 'Success';
        obj_notify.text = 'Yeah, nice! The picture has a perfect quality.';
        obj_notify.type = 'success';
        $(window).trigger('notify',obj_notify);
      }

    }

  showHideLayer(d){
     this.getLayerById(d.id).hidden = d.hidden;
     this.currentLayers = this.getCurrentViewTable();
    $(window).trigger('bf-transform', {'action': 'show-hide', 'idLayer': d.id});
   }

   showHideAdjustment(d){
     this.getLayerById(d.id).showAdjustment = !this.getLayerById(d.id).showAdjustment;
     this.currentLayers = this.getCurrentViewTable();
     return this.getLayerById(d.id).showAdjustment;
   }

  /*
  constructor(){

    $(window).on('bfLayers-addLayer',(e,data) => {
      if ( data != undefined )
      {
        this.addLayer(data);
        //this.data.push(data);
      }

    })

  }

  @computed get currentLayer()
  {
    return this.getCurrentViewTable();
  }
  */

  prepareLayer(obj){
    var obj2 = _.clone(obj);
    obj2.idImg = obj.idImg;
    if ( obj2.idLayer != undefined )
    {
      obj2.id = obj.idLayer;
    }
    else
    {
      obj2.id = Date.now();
    }
    return obj2;
  };

  addLayer(obj)
  {


    var obj2 = _.clone(obj);
    obj2.idImg = obj.idImg;
    if ( obj2.idLayer != undefined )
    {
      obj2.id = obj.idLayer;
    }
    else
    {
      obj2.id = Date.now();
    }

    this.getCurrentView().count++;

    this.getCurrentView().table.unshift(obj2);

    this.currentLayers = this.getCurrentViewTable();
    return obj2;
  };


  removeLayerById(id_number)
  {
    var scope = this;

    var find = null;
    for ( var i in scope.getCurrentView().table )
    {
      if ( scope.getCurrentView().table[i].id == id_number )
      {
        find = scope.getCurrentView().table[i];
      }
    }

    scope.getCurrentView().table = _.without(scope.getCurrentView().table, find);
    $(window).trigger('bf-transform',{'action':'remove','idLayer':id_number});
    var obj = {
      data : scope.getCurrentView().table
    }
    $(window).trigger('Layers-renderLayers',obj);
    this.currentLayers = this.getCurrentViewTable();
    return scope.getCurrentView().table;
  }

  getLayerById(id_number)
  {
    var scope = this;

    var currentTable = scope.getCurrentView().table;
    for ( var i in currentTable )
    {
      if ( currentTable[i].id == id_number )
      {
        return  currentTable[i];
      }
    }
    return null;

    // remove it...
    var layerIndex = _.findIndex( scope.getCurrentView().table ,{ id : id_number });

    //console.log('found: ',layerIndex, scope.getCurrentView().table[layerIndex]);
    return scope.getCurrentView().table[layerIndex];
  }

  getLayersCurrentView()
  {
    var scope = this;
    return scope.getCurrentView().table;
  }

  getLayerByIdImg(id_number)
  {
    var scope = this;

    return _.findIndex( scope.getCurrentView().table ,{ idImg : id_number });
  }

  getAll()
  {
    throw 'This not alwasy will have everty sides... Use BFSingleProject';
    return this.views;
  }

  getData()
  {
    return this.getCurrentView().table;
  }

  getCurrentView()
  {
    for ( var i in this.views )
    {
      if ( this.views[i].id == this.currentViewId )
      {
        return this.views[i];
      }
    }
  }

  getCurrentViewTable(layer_id)
  {
    for ( var i in this.views )
    {

      if ( this.views[i].id == this.currentViewId )
      {
        if ( layer_id )
        {
          return this.views[i].table[layer_id];
        }

        return this.views[i].table;
      }
    }
  }


  getCurrentViewTableId(layer_id)
  {
    for ( var i in this.views )
    {
      if ( this.views[i].id == this.currentViewId )
      {
        return this.views[i].table[layer_id].id;
      }
    }
  }

  setCurrentViewTable(table)
  {
    for ( var i in this.views )
    {
      if ( this.views[i].id == this.currentViewId )
      {
        this.views[i].table = table;
      }
    }
  }

  layerUp(idLayer){
    var table = this.getCurrentViewTable();

    var sortTable = [];
    for ( var i = 0; i < table.length; i++ ){
      sortTable.push(table[i].idLayer);
    }
    for ( var i = 0; i < sortTable.length; i++ ){
      if ( sortTable[i] == idLayer )
      {
        if ( i > 0 ){
          let pre = sortTable[i-1];
          sortTable[i-1] = idLayer;
          sortTable[i] = pre;
        }
      }
    }

    this.sort(sortTable);


  }

  layerDown(idLayer){
    var table = this.getCurrentViewTable();

    var sortTable = [];
    for ( var i = 0; i < table.length; i++ ){
      sortTable.push(table[i].idLayer);
    }
    for ( var i = 0; i < sortTable.length; i++ ){
      if ( sortTable[i] == idLayer )
      {
        if ( i < sortTable.length-1 ){
          let next = sortTable[i+1];
          sortTable[i+1] = idLayer;
          sortTable[i] = next;
          break;
        }
      }
    }

    this.sort(sortTable);

  }

  sort(order){

    var layersSort = order;

    var obj = new Object();
    obj.layersSort = layersSort.reverse();

    var newLayersTable = [];
    var table = this.getCurrentViewTable();

    for ( var i in layersSort )
    {
      for ( var j in table )
      {
        if ( table[j].id == parseInt(layersSort[i]) )
        {
          newLayersTable.push(table[j]);
        }
      }
    }

    let reversLayers = newLayersTable.reverse();
    this.setCurrentViewTable( newLayersTable );

    let layersObj = {
      data : reversLayers
    }

    $(window).trigger('Layers-renderLayers',layersObj);

    $(window).trigger('Layers-sortLayers',obj);
    this.currentLayers = this.getCurrentViewTable();
  }



  addViews(viewsObj)
  {

    this.views = viewsObj.views;
    for ( var i in this.views )
    {
      this.views[i].table = new Array();
      this.views[i].count = 1;
    }
  }


  cleanView(id)
  {
    for ( var i in this.views )
    {
      if ( this.views[i].id == id )
      {
        this.views[i].table = new Array();
        this.views[i].count = 1;
      }
    }
  }



  setCurrentViewId(id)
  {
    this.currentViewId = id;
   // console.log('id',id);
    this.currentLayers = this.getCurrentViewTable();
  }

}



let bfLayers = new BFLayers();
export default bfLayers;